import React, { useEffect, useState } from "react";
import axios from "../../axiosConfig"; // Cấu hình axios để gọi API
import { toast, ToastContainer } from "react-toastify";
import { FaStar } from "react-icons/fa";
import { FaRegHeart } from "react-icons/fa";
import { IoMdHeart } from "react-icons/io";
import { FaLocationDot } from "react-icons/fa6";
import { getToken } from "../Login/app/static";
import { Link, Navigate, useNavigate } from "react-router-dom"; // Import Link if you need navigation
import { useRoom } from "../context/RoomContext";
const API_URL = "https://homifyme-backend-oreg.onrender.com/rooms/available";
const FAVORITE_API_URL = "https://homifyme-backend-oreg.onrender.com/favorites/create/";
const FAVORITE_LIST_URL = "https://homifyme-backend-oreg.onrender.com/favorites"; 
const RoomList = () => {
  const { room } = useRoom();

  const [rooms, setRooms] = useState([]);
  const [favorites, setFavorites] = useState([]);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  console.log(room, "room");
  useEffect(() => {
    const fetchRooms = async () => {
      try {
        const response = await axios.get("/rooms/all");
        setRooms(response.data);
      } catch (error) {
        toast.error("Không thể lấy danh sách phòng.");
        setError(error.message);
      } finally {
        setLoading(false);
      }
    };
    fetchRooms();
  }, []);
  // const toggleFavorite = (id) => {
  //   setFavorites((prevFavorites) => {
  //     if (prevFavorites.includes(id)) {
  //       return prevFavorites.filter((favoriteId) => favoriteId !== id);
  //     } else {
  //       return [...prevFavorites, id];
  //     }
  //   });
  // };
  const toggleFavorite = (id) => {
      const token = getToken();
      if (!token) {
        navigate("/login");
        return;
      }
  
      // Thêm hoặc xóa phòng khỏi danh sách yêu thích
      setFavorites((prevFavorites) => {
        const isFavorited = prevFavorites.includes(id);
  
        if (!isFavorited) {
          // Thêm vào danh sách yêu thích
          fetch(`${FAVORITE_API_URL}${id}`, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          })
            .then((response) => response.json())
            .then((data) => {
              console.log("Added to favorites:", data);
              setFavorites([...prevFavorites, id]); // Cập nhật state không cần reload
              window.location.reload();
            })
            .catch((error) => console.error("Error adding to favorites:", error));
        } else {
          // Xóa khỏi danh sách yêu thích
          setFavorites(prevFavorites.filter((favoriteId) => favoriteId !== id));
        }
  
        return prevFavorites; // Giữ nguyên trạng thái hiện tại trong lúc cập nhật
      });
    };
    const handleDelete = async (roomId) => {
      const token = getToken(); // Lấy token từ hàm getToken hoặc nơi lưu token
  
      try {
        const response = await fetch(
          `https://homifyme-backend-oreg.onrender.com/favorites/delete/${roomId}`,
          {
            method: "DELETE",
            headers: {
              Authorization: `Bearer ${token}`, // Đưa Bearer token vào tiêu đề
              "Content-Type": "application/json",
            },
          }
        );
  
        if (!response.ok) {
          throw new Error("Failed to delete room");
        }
        window.location.reload();
        // Sau khi xóa thành công, cập nhật lại danh sách các phòng
      } catch (error) {
        console.error("Error deleting room:", error);
      }
    };
    const handleRoomClick = (e, roomId) => {
      const token = getToken();
      if (!token) {
        e.preventDefault();
        navigate("/login");
      } else {
        navigate(`/house-list/${roomId}`);
      }
    };

  if (loading) {
    return (
      <div className="text-center py-8 text-xl text-blue-500">Đang tải...</div>
    );
  }
  return (
    <div className="mx-auto flex flex-col items-center mb-[50px]  bg-gray-100">
      <div className=" flex justify-items-start w-[100%] ">
        <h1 className="text-[27px] font-bold mb-6 mx-[90px]">
          Danh sách phòng
        </h1>
      </div>
      <div className="  flex flex-col w-[88%]  shadow-xl h-[100vh] bg-white">
        <ToastContainer />

        <h2 className="mx-[25px] text-[18px] font-semibold mt-[30px]">
          Tổng {!room?.lenght ? 0 : room?.length} kết quả
        </h2>

        <div className="flex flex-wrap gap-[20px] justify-center mb-[50px]">
          {Array.isArray(rooms) &&
            rooms.map((room) => (
              <div
                key={room._id}
                style={{
                  width: "18%",
                  borderRadius: "8px",
                  overflow: "hidden",
                }}
              >
                <div className="relative">
                  <img
                    src={
                      room.images.find((img) => img.main)?.url ||
                      room.images[0]?.url
                    }
                    onClick={(e) => handleRoomClick(e, room._id)}
                    alt={room.name}
                    className="w-full h-[190px] object-cover rounded-[8px] cursor-pointer"
                  />
                  {favorites.includes(room._id) ? (
                    <IoMdHeart
                      fill="red"
                      className="absolute bottom-2 right-2 cursor-pointer text-white w-[30px] h-[30px] transition-transform duration-200 ease-in-out transform hover:scale-125"
                      onClick={() => handleDelete(room._id)}
                    />
                  ) : (
                    <FaRegHeart
                      fill="white"
                      className="absolute bottom-2 right-2 cursor-pointer text-white w-[25px] h-[25px] transition-transform duration-200 ease-in-out transform hover:scale-125"
                      onClick={() => toggleFavorite(room._id)}
                    />
                  )}
                </div>

                <div>
                  <h3
                    className="hover:text-orange-500 cursor-pointer"
                    onClick={(e) => handleRoomClick(e, room._id)}
                    style={{
                      margin: "10px 0",
                      fontSize: "15px",
                      fontWeight: "500",
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      maxWidth: "230px",
                    }}
                  >
                    {room.name}
                  </h3>
                  <p
                    style={{
                      margin: "5px 0",
                      color: "#555",
                      fontSize: "12px",
                      display: "flex",
                      alignItems: "center",
                      gap: "5px",
                    }}
                  >
                    <label>Giá:</label>
                    {room.room_quantity > 0 ? (
                      <p
                        style={{
                          color: "red",
                          fontWeight: "500",
                          fontSize: "14px",
                        }}
                      >
                        {room.price}
                      </p>
                    ) : (
                      <p
                        style={{
                          color: "red",
                          fontWeight: "500",
                          fontSize: "14px",
                        }}
                      >
                        Sold Out
                      </p>
                    )}
                  </p>

                  <p
                    className="mt-[10px] mb-[20px]"
                    style={{
                      fontSize: "12px",
                      display: "flex",
                      alignItems: "center",
                      width: "500px",
                      gap: "5px",
                    }}
                  >
                    <label className="font-semibold text-[14px] flex gap-[20px]">
                      <FaStar className="text-yellow-400 w-[23px] h-[23px]" />
                      <FaStar className="text-yellow-400 w-[23px] h-[23px]" />
                      <FaStar className="text-yellow-400 w-[23px] h-[23px]" />
                      <FaStar className="text-yellow-400 w-[23px] h-[23px]" />
                      <FaStar className="text-yellow-400 w-[23px] h-[23px]" />
                    </label>
                    <p className="mt-[3px]">{room.ratting}</p>
                  </p>
                  <p
                    style={{
                      margin: "5px 0",
                      color: "#555",
                      display: "flex",
                      alignItems: "center",
                      gap: "5px",
                    }}
                  >
                    <FaLocationDot />
                    <p
                      style={{
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        maxWidth: "200px",
                        fontSize: "12px",
                      }}
                    >
                      {room.address.map((addr, index) => (
                        <p key={index}>
                          {addr.detail && `${addr.detail}, `}
                          {addr.ward && `${addr.ward}, `}
                          {addr.district && `${addr.district}, `}
                          {addr.city}
                        </p>
                      ))}
                    </p>
                  </p>
                </div>
              </div>
            ))}
        </div>
      </div>
    </div>
  );
};

export default RoomList;
